/**
 * *
 * @description fix leaflet full screen
 * @version 1.0.0
 * @author [Peerapong Srisom]
 */

export default function LeafletFullScreenFix() {
  return '<div class="fullscreen-icon" onClick="var e = document.documentElement; if(e.requestFullscreen){ e.requestFullscreen() } if(document.exitFullscreen){ document.exitFullscreen(); }">.</div>';
}